/* Husha cart drawer (copy of nimbao.com): countdown, delivery protection add, upsell add, checkout spinner.
   Event delegation, so it survives the drawer re-render (cart-drawer replaces #CartDrawer innerHTML). */
(function () {
  if (window.__hsCart) return;
  window.__hsCart = true;
  var KEY = 'hs_cart_timer_end', LEN = 600;

  function endTime() {
    var now = Date.now(), end = 0;
    try { end = parseInt(sessionStorage.getItem(KEY) || '0', 10); } catch (e) {}
    if (!end || end <= now) {
      end = now + LEN * 1000;
      try { sessionStorage.setItem(KEY, String(end)); } catch (e) {}
    }
    return end;
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    var els = document.querySelectorAll('[data-hs-countdown]');
    if (!els.length) return;
    var left = Math.max(0, Math.round((endTime() - Date.now()) / 1000));
    var m = pad(Math.floor(left / 60)), s = pad(left % 60);
    els.forEach(function (el) {
      var sp = el.querySelectorAll('span');
      if (sp[0] && sp[0].textContent !== m) sp[0].textContent = m;
      if (sp[1] && sp[1].textContent !== s) sp[1].textContent = s;
    });
  }
  setInterval(tick, 1000);
  document.addEventListener('DOMContentLoaded', tick);
  new MutationObserver(function () { tick(); }).observe(document.documentElement, { childList: true, subtree: true });
  tick();

  function addToCart(id, btn) {
    var drawer = document.querySelector('cart-drawer');
    if (btn) btn.disabled = true;
    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble' })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status || !data.sections) { if (btn) btn.disabled = false; return; }
        if (drawer && drawer.renderContents) drawer.renderContents(data);
      })
      .catch(function () { if (btn) btn.disabled = false; });
  }

  function upsellVariant(card) {
    var json = card.querySelector('[data-hs-upsell-variants]');
    if (!json) return null;
    var variants; try { variants = JSON.parse(json.textContent); } catch (e) { return null; }
    var vals = Array.prototype.map.call(card.querySelectorAll('[data-hs-upsell-option]'), function (s) { return s.value; });
    return variants.filter(function (v) {
      return vals.every(function (val, i) { return v['option' + (i + 1)] === val; });
    })[0] || null;
  }
  function money(cents) {
    return window.Shopify && Shopify.formatMoney && window.hsMoneyFormat ? Shopify.formatMoney(cents, window.hsMoneyFormat) : null;
  }

  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-hs-upsell-option]');
    if (!sel) return;
    var card = sel.closest('[data-hs-upsell]');
    var v = upsellVariant(card);
    if (v) {
      card.setAttribute('data-variant-id', v.id);
      card.classList.toggle('hs-unavailable', !v.available);
    }
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    var prot = t.closest && t.closest('[data-nb-protect-add]');
    if (prot) {
      e.preventDefault();
      addToCart(prot.closest('#nb-protect').getAttribute('data-variant-id'), prot);
      return;
    }
    var up = t.closest && t.closest('[data-hs-upsell-add]');
    if (up) {
      e.preventDefault();
      var card = up.closest('[data-hs-upsell]');
      var v = upsellVariant(card);
      addToCart(v ? v.id : card.getAttribute('data-variant-id'), up);
      return;
    }
    var co = t.closest && t.closest('[data-hs-checkout]');
    if (co && !co.disabled) {
      co.classList.add('loading');
      var sp = co.querySelector('.loading-overlay__spinner');
      if (sp) sp.classList.remove('hidden');
      setTimeout(function () {
        if (document.location.pathname.indexOf('/checkout') > -1) return;
        co.classList.remove('loading');
        if (sp) sp.classList.add('hidden');
      }, 8000);
    }
  });
})();
